import React from 'react'
import { Field } from 'formik'
import get from 'lodash/get'
import { Radio, Text, View } from 'oio-react'
import PropTypes from 'prop-types'

const ProductListItem = ({ borderStyle, onChange, product }) => {
   const handleChange = (form, field, changeEvent) => {
      // Ensure we don't override Formik's default field onChange behaviour,
      // which is to set the field value on the form.
      form.setFieldValue(field.name, changeEvent.target.value)
      if (onChange) {
         onChange(changeEvent.target.value)
      }
   }

   const productPrice = product.price > 0
      ? product.price.toLocaleString('en-US', { style: 'currency', currency: 'USD' })
      : 'Free'

   return (
      <View
         display="flex"
         width="100%"
         padding="15px 0px"
         borderTop={borderStyle}>
         <View flex="0 0 auto" width="36px">
            <Field
               name="products"
               type="radio"
               render={({ form, field }) => (
                  <Radio
                     // TODO: This line below should not be needed after Formik is upgraded to 2+
                     defaultChecked={get(form.values, 'products') === product.id}
                     {...field}
                     highlightColor="#35b865"
                     name="products"
                     value={product.id}
                     required
                     onChange={changeEvent => handleChange(form, field, changeEvent)}
                  />
               )}
            />
         </View>
         <View flex="1 1 auto">
            <Text size="1.5" weight="medium">
               {product.name}
            </Text>
            <Text size="1.5">{product.description}</Text>
         </View>
         <View flex="0 0 auto" width="72px" textAlign="right">
            <Text size="1.5">
               {productPrice}
            </Text>
         </View>
      </View>
   )
}

ProductListItem.propTypes = {
   borderStyle: PropTypes.string,
   onChange: PropTypes.func.isRequired,
   product: PropTypes.object.isRequired
}

ProductListItem.defaultProps = {
   borderStyle: '1px solid #eee'
}

export default ProductListItem
